/*
 * @Author: 孙福聪
 * @Date: 2019-01-16 16:01:49
 * @Last Modified by: liushengyu
 * @Last Modified time: 2020-04-24 08:49:45
 */
// 接口配置
// 服务器接口根地址
const isProduction = process.env.NODE_ENV === "production";

// 服务器地址
const SERVER_BASE_URL = isProduction ? "" : ""; // 项目api地址
export default SERVER_BASE_URL;
